module.exports = __webpack_public_path__ + "img/no-person.3a104f50.png";